"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteFieldVirtualized = void 0;
var react_1 = __importDefault(require("react"));
var formik_material_ui_lab_1 = require("formik-material-ui-lab");
var useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
var ListSubheader_1 = __importDefault(require("@material-ui/core/ListSubheader"));
var styles_1 = require("@material-ui/core/styles");
var react_window_1 = require("react-window");
var core_1 = require("@material-ui/core");
var formik_1 = require("formik");
var autocompleteDataFunctions_1 = require("./autocompleteDataFunctions");
var utils_1 = require("../../utils");
// код, кроме непосредственно компонента AutocompleteFieldVirtualized это копипаста из https://v4.mui.com/components/autocomplete/#virtualization
var LISTBOX_PADDING = 8; // px
function renderRow(props) {
    var data = props.data, index = props.index, style = props.style;
    return react_1.default.cloneElement(data[index], {
        style: __assign(__assign({}, style), { top: style.top + LISTBOX_PADDING }),
    });
}
var OuterElementContext = react_1.default.createContext({});
var OuterElementType = react_1.default.forwardRef(function (props, ref) {
    var outerProps = react_1.default.useContext(OuterElementContext);
    return react_1.default.createElement("div", __assign({ ref: ref }, props, outerProps));
});
function useResetCache(data) {
    var ref = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        if (ref.current != null) {
            ref.current.resetAfterIndex(0, true);
        }
    }, [data]);
    return ref;
}
// Adapter for react-window
var ListboxComponent = react_1.default.forwardRef(function ListboxComponent(props, ref) {
    var children = props.children, other = __rest(props, ["children"]);
    var itemData = react_1.default.Children.toArray(children);
    var theme = styles_1.useTheme();
    var smUp = useMediaQuery_1.default(theme.breakpoints.up('sm'), { noSsr: true });
    var itemCount = itemData.length;
    var itemSize = smUp ? 36 : 48;
    var getChildSize = function (child) {
        if (react_1.default.isValidElement(child) && child.type === ListSubheader_1.default) {
            return 48;
        }
        return itemSize;
    };
    var getHeight = function () {
        if (itemCount > 8) {
            return 8 * itemSize;
        }
        return itemData.map(getChildSize).reduce(function (a, b) { return a + b; }, 0);
    };
    var gridRef = useResetCache(itemCount);
    return (react_1.default.createElement("div", { ref: ref },
        react_1.default.createElement(OuterElementContext.Provider, { value: other },
            react_1.default.createElement(react_window_1.VariableSizeList, { itemData: itemData, height: getHeight() + 2 * LISTBOX_PADDING, width: "100%", ref: gridRef, outerElementType: OuterElementType, innerElementType: "ul", itemSize: function (index) { return getChildSize(itemData[index]); }, overscanCount: 5, itemCount: itemCount }, renderRow))));
});
var useStyles = styles_1.makeStyles({
    listbox: {
        boxSizing: 'border-box',
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
});
var renderGroup = function (params) { return [
    react_1.default.createElement(ListSubheader_1.default, { key: params.key, component: "div" }, params.group),
    params.children,
]; };
exports.AutocompleteFieldVirtualized = function (props) {
    var options = props.options, label = props.label, fieldName = props.fieldName, _a = props.multiple, multiple = _a === void 0 ? true : _a, _b = props.required, required = _b === void 0 ? false : _b, renderTags = props.renderTags;
    var classes = useStyles();
    var _c = formik_1.useFormikContext(), touched = _c.touched, errors = _c.errors;
    var fieldTouched = utils_1.getObjValueByDotProp(touched, fieldName);
    var fieldErrors = utils_1.getObjValueByDotProp(errors, fieldName);
    var renderInput = function (params) { return (react_1.default.createElement(core_1.TextField, __assign({}, params, { name: fieldName, error: fieldTouched && !!fieldErrors, helperText: fieldTouched && fieldErrors, label: label, variant: "outlined", color: "primary", required: required }))); };
    return (react_1.default.createElement(formik_1.Field, __assign({ id: "autocomplete-field-virtualized", component: formik_material_ui_lab_1.Autocomplete, fullWidth: true, size: "small", name: fieldName, multiple: multiple, disableClearable: true, filterSelectedOptions: false, getOptionLabel: autocompleteDataFunctions_1.getOptionLabelDefault, getOptionSelected: autocompleteDataFunctions_1.getOptionSelectedDefault, disableListWrap: true, classes: classes, ListboxComponent: ListboxComponent, renderGroup: renderGroup, options: options, renderInput: renderInput, renderOption: function (option) { return react_1.default.createElement(core_1.Typography, { noWrap: true }, option.title); } }, (renderTags && { renderTags: renderTags }))));
};
